import numbro from 'numbro'

export const round = (value) => Number(numbro(value).format({ mantissa: 2 }))
